"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Photo = void 0;
var React = __importStar(require("react"));
var bind_1 = __importDefault(require("classnames/bind"));
var styles = __importStar(require("./styles.modules.css"));
var text_1 = require("../text");
var cx = bind_1.default.bind(styles);
var defaultProps = {
    size: "medium",
    style: "square",
};
var getInitialsFromName = function (name) {
    if (!name) {
        return ""; // Required due to some legacy data structures, old accounts may not have first/last or full name at all.
    }
    var firstLast = name.split(" ");
    var last = "";
    var first = firstLast[0][0];
    if (firstLast.length > 1) {
        last = firstLast[1][0];
    }
    return "".concat(first).concat(last);
};
var Photo = /** @class */ (function (_super) {
    __extends(Photo, _super);
    function Photo(props) {
        var _this = _super.call(this, props) || this;
        _this.attemptLoad = function (url) {
            if (!url) {
                return;
            }
            _this.image = document.createElement("img");
            _this.image.onload = function () {
                _this.setState({ src: url });
            };
            _this.image.onerror = function () {
                return;
            };
            _this.image.src = url;
        };
        _this.attemptUnload = function () {
            _this.setState({ src: null });
            if (_this.image) {
                _this.image.onload = null;
                _this.image.onerror = null;
                _this.image = null;
            }
        };
        _this.state = {};
        return _this;
    }
    Photo.prototype.componentDidMount = function () {
        this.attemptLoad(this.props.url);
    };
    Photo.prototype.componentWillUnmount = function () {
        this.attemptUnload();
    };
    Photo.prototype.UNSAFE_componentWillReceiveProps = function (props) {
        // TODO: Refactor
        if (props.url) {
            this.attemptLoad(props.url);
        }
        else {
            this.attemptUnload();
        }
    };
    Photo.prototype.render = function () {
        var _a;
        var _b = this.props, name = _b.name, size = _b.size, style = _b.style, className = _b.className;
        var blur = this.props.blur;
        var inner;
        var initials = getInitialsFromName(name);
        inner = React.createElement(text_1.Text, { className: styles.initials }, initials);
        var inline = {};
        var src = this.state.src;
        var hasBackground = false;
        if (src) {
            inline.backgroundImage = "url(".concat(src, ")");
            hasBackground = true;
            inner = null;
        }
        else {
            inline = {};
            blur = false;
        }
        var className_ = cx((_a = {
                outer: true
            },
            _a[size] = true,
            _a[style] = true,
            _a.blur = blur,
            _a.hasBackground = hasBackground,
            _a[className] = className,
            _a));
        return (React.createElement("div", { className: className_, style: inline }, inner));
    };
    Photo.defaultProps = defaultProps;
    return Photo;
}(React.Component));
exports.Photo = Photo;
exports.default = Photo;
//# sourceMappingURL=photo.js.map